const shadows = {
  default: '0 1px 3px 0 rgba(75, 75, 75, 0.4);',
  md: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 #89cdf4',
  lg: '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
  lgblue: '0 0px 10px 0px rgba(0,0,0,0.11), 0 0px 12px 3px #89cdf4',
  inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  none: 'none',
};

module.exports = shadows;



// WEBPACK FOOTER //
// ./src/helpers/shadow-styles.js